import { EntityType } from "@app/models"
import { EntityTypeEnum } from "enums/entity-type.enum"


export function selectedEntityActive(storage): EntityType {
    return { id: storage?.country_selected?.editoras[0]?.id, tipo: EntityTypeEnum.Editora }
}
